import {
  Injectable
} from '@angular/core';
import 'rxjs/add/operator/map';
import {
  Observable
} from 'rxjs/Observable';
import {
  Http,
  Headers,
  RequestOptions
} from '@angular/http';
import {
  GlobalService
} from "./global.config";
import {
  VehiculeInfo,
  DeviceLabel,
  DriverLabel,
  GroupLabel,
  Vehicule,
  Groupe,
  Driver
} from '../objects/index';
import {
  User
} from "../objects/real-time";
import {Events } from 'ionic-angular';

@Injectable()
export class VehiculeService {
  vehicules: VehiculeInfo[] = [];
  public toastyAdd: Boolean = false;
  public toastyUpdate: Boolean = false;
  groupLabels: GroupLabel[] = [];
  driverLabels: DriverLabel[] = [];
  deviceLabels: DeviceLabel[] = [];
  public bigCurrentPage: number = 1;
  currentuser: User;
  constructor(private _http: Http,private globalService : GlobalService,public events: Events) {
    this.currentuser = JSON.parse(localStorage.getItem('currentuser'));
    
  }
  
  add(vehicule: Vehicule, idDevice: number, idGroups: string, idDriver: number, deviceNumber: number): Observable < Vehicule > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    let options = new RequestOptions({
      headers: headers
    });
    let body = JSON.stringify(vehicule);
    return this._http.post(dns + 'vehicules/?idDevice=' + idDevice + '&idGroups=' + idGroups + '&idDriver=' + idDriver + '&deviceNumber=' + deviceNumber, vehicule, options).map(res => res.json());
  }

  update(vehicule: Vehicule, idGroups: string, idDriver: number, deviceNumber: number): Observable < Vehicule > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    let options = new RequestOptions({
      headers: headers
    });
    let body = JSON.stringify(vehicule);
    return this._http.put(dns + 'vehicules/?idGroups=' + idGroups + '&idDriver=' + idDriver + '&deviceNumber=' + deviceNumber, vehicule, options).map(res => res.json());
  }

  addGroup(name: string): Observable < Groupe > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.get(dns + 'groupes/byName/?groupeName=' + name, {
      headers: headers
    }).map(res => res.json());
  }
  addDriver(name: string): Observable < Driver > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.get(dns + 'drivers/byName/?driverName=' + name, {
      headers: headers
    }).map(res => res.json());
  }

  getGroupsVehicule(id: number): Observable < GroupLabel[] > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.get(dns + 'vehicules/groups/' + id, {
      headers: headers
    }).map(res => res.json());
  }

  getOne(id: number): Observable < VehiculeInfo > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.get(dns + 'vehicules/' + id, {
      headers: headers
    }).map(res => res.json());
  }

  assignement(idVehicule: number, idDriver: number): Observable < any > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.get(dns + 'vehicules/assignement/?idVehicule=' + idVehicule + '&idDriver=' + idDriver, {
      headers: headers
    }).map(res => res.json());
  }

  getListVehicules(page: number, size: number): Observable < any > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.get(dns + 'vehicules/list' + '?page=' + page + '&size=' + size, {
      headers: headers
    }).map(res => res.json());
  }

  delete(id: number): Observable < Boolean > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.delete(dns + 'vehicules/' + id, {
      headers: headers
    }).map(res => res.json());
  }

  getGroupsLabel(): Observable < GroupLabel[] > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.get(dns + 'groupes/labels', {
      headers: headers
    }).map(res => res.json());
  }
  getDriversLabel(): Observable < DriverLabel[] > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.get(dns + 'drivers/labels', {
      headers: headers
    }).map(res => res.json());
  }
  getDevicesLabel(): Observable < DeviceLabel[] > {
    let dns = this.globalService.getDns();
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    headers.append('Authorization', this.currentuser.token);
    return this._http.get(dns + 'devices/labels', {
      headers: headers
    }).map(res => res.json());
  }

  getVehicule(idVehicule: number) {
    if (this.vehicules.length != 0) {
      console.log(this.vehicules)
      return this.vehicules.find(vehicule => vehicule.idVehicule === idVehicule);
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/providers/vehicule.service.ts